<template >
  <div>
    <v-card class="rounded-lg mt-2" elevation="2">
      <v-row justify="center">
        <v-col cols="12" lg="11" md="11" sm="12" xs="12">
          <div class="track-title-row">
            <v-card-title>
              <div class="subject-title">{{ $t('TRACKS.title') }}</div>
            </v-card-title>
            <v-btn
              id="tracks-create-button"
              dark
              color="blue"
              @click="$router.push('/dashboard/tracks/new')"
            >
              {{ $t('TRACKS.create_button') }}
              <v-icon dark class="ml-2">{{ icon.mdiPlus }}</v-icon>
            </v-btn>
          </div>

          <v-col cols="12" class="mx-4 my-2 pa-0">
            <v-text-field
              id="tracks-search-input"
              class="search-input"
              v-model="search"
              :append-icon="icon.mdiMagnify"
              :label="$t('TRACKS.search')"
              single-line
              hide-details
              flat
              outlined
            ></v-text-field>
          </v-col>

          <v-data-table
            :headers="headers.map(h => ({ ...h, text: $t('TRACKS.headers.' + h.text) }))"
            :items="myTracks"
            :loading-text="$t('TRACKS.loading')"
            :loading="loading"
            :items-per-page="10"
            :search="search"
          >
            <template v-slot:[`item.content.${$i18n.locale}.title`]="{ item }">
              <tr>
                <td class="truncate">{{ item.content[$i18n.locale].title }}</td>
              </tr>
            </template>
            <template v-slot:[`item.manager.action`]="{ item }">
              <v-row justify="end">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'tracks-edit-button-' + item.id"
                      icon
                      v-on="on"
                      @click="editItem(item)"
                    >
                      <v-icon> {{ icon.mdiPencil }} </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("TOOLTIP.edit_button") }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="'tracks-delete-button-' + item.id"
                      icon
                      v-on="on"
                      @click="deleteItem(item)"
                    >
                      <v-icon color="red"> {{ icon.mdiDelete }} </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("TOOLTIP.delete_button") }}</span>
                </v-tooltip>
              </v-row>
            </template>

            <template v-slot:[`item.papers`]="{ item }">
              <v-btn
                icon
                @click="goToPapers(item.id)"
                :id="'tracks-see-papers-button-' + item.id"
              >
                <v-icon> {{ icon.mdiFileOutline }} </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogDelete" persistent max-width="50vw">
        <v-card>
          <v-card-title class="primary-title mx-auto"
            >{{ $t('TRACKS.delete_card.title') }}</v-card-title
          >
          <v-divider class="mx-4"></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              id="track-delete-cancel-button"
              text
              class="red--text"
              @click="closeDelete"
            >
              {{ $t('TRACKS.delete_card.cancel_button') }}
            </v-btn>

            <v-btn
              id="track-delete-save-button"
              depressed
              color="green"
              class="white--text"
              @click="deleteItemConfirm"
            >
              {{ $t('TRACKS.delete_card.delete_button') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <v-snackbar
      v-model="snackbar.show"
      top
      right
      :timeout="4000"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { mdiDelete, mdiPencil, mdiFileOutline, mdiMagnify, mdiPlus } from "@mdi/js";
export default {
  data() {
    return {
      icon: {
        mdiDelete,
        mdiPencil,
        mdiFileOutline,
        mdiMagnify,
        mdiPlus
      },
      dialog: false,
      dialogDelete: false,
      search: "",
      editedIndex: -1,
      headers: [
        { text: "title", value: `content.${this.$i18n.locale}.title` },
        {
          text: "manage",
          value: "manager.action",
          sortable: false,
          align: "end",
        },
        {
          text: "papers",
          value: "papers",
          sortable: false,
          align: "end",
        },
      ],
      editedItem: {
        title: "",
        color: "",
      },
      defaultItem: {
        title: "",
        color: "#FF00FF",
      },
    };
  },
  methods: {
    async deleteTrack() {
      let deleted = await this.$store.dispatch(
        "deleteTracks",
        this.editedItem.id
      );
      this.$emit("close");
      if (deleted) {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Success on delete track!",
          color: "success",
        });
      } else {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Oops... Error on delete track",
          color: "error",
        });
      }
      await this.$store.dispatch("getTracks");
    },

    editItem(item) {
      this.$router.push(`/dashboard/tracks/${item.id}/edit`);
    },

    deleteItem(item) {
      this.editedIndex = this.currentTracks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.currentTracks.splice(this.editedIndex, 1);
      await this.deleteTrack();
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.currentTracks[this.editedIndex], this.editedItem);
      } else {
        this.currentTracks.push(this.editedItem);
      }
      this.close();
    },
    goToPapers(id) {
      this.$router.push(`/dashboard/tracks/${id}/papers`);
    },
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    currentTracks() {
      return this.$store.getters.getTracks || [];
    },
    myTracks() {
      if (this.isAdmin || this.isEventAdmin) {
        return this.currentTracks;
      } else if (this.user?.tracks != undefined) {
        return this.currentTracks.filter((track) =>
          this.user?.tracks.includes(track.id)
        );
      } else return [];
    },
    user() {
      return this.$store.getters.getUser;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isEventAdmin() {
      return this.$store.getters.isEventAdmin;
    },
    loading() {
      if (this.$store.getters.getTracks == null) return true;
      return false;
    },
  },
  async created() {
    await this.$store.dispatch("getTracks");
  },
};
</script>

<style scoped>
.subject-title {
  font-size: 120%;
  font-weight: 700;
  color: #4f4f4f;
  font-family: "Open Sans", sans-serif;
}

.text-wrap {
  max-width: 700px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.truncate {
  max-width: 60vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.track-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.track-title-row .v-btn {
  margin-right: 16px;
}

.search-input {
  max-width: 500px;
}

@media (max-width: 390px) {
  .track-title-row {
    flex-direction: column;
    margin-bottom: 24px;
  }
  
  .track-title-row .v-btn {
    margin-right: 0;
  }
}

@media (max-width: 720px) {
  .search-input {
    max-width: calc(100% - 32px);
  }
}
</style>
